"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const office_ui_fabric_react_1 = require("office-ui-fabric-react");
const PageContent_1 = __importDefault(require("../PageContent"));
const Api_1 = require("../../lib/Api");
const ApiHook_1 = require("../../lib/ApiHook");
const styles = {
    sectionHeading: {
        root: {
            borderBottom: '1px solid rgb(243, 242, 241)',
            paddingBottom: '10px'
        }
    },
    table: {
        width: '100%',
        marginTop: '20px'
    },
    textField: {
        fieldGroup: {
            borderColor: '#cbced0'
        }
    }
};
const SettingsPage = () => {
    const [serverSettings] = ApiHook_1.useApiHook(Api_1.getSettings);
    const [saveApi, persistSettings] = ApiHook_1.useSideEffectApiHook(Api_1.updateSettings);
    const [localSettings, setLocalSettings] = react_1.useState();
    const isLoading = serverSettings.isLoading || saveApi.isLoading;
    const isInitialLoadError = serverSettings.isError;
    // Update localSettings if serverSettings change
    react_1.useEffect(() => {
        if (serverSettings.data) {
            setLocalSettings(serverSettings.data);
        }
    }, [serverSettings.data]);
    // Helper to sync modifications to form with localSettings state
    const updateHarvestMapping = (index, field) => (_, value) => {
        if (!(localSettings === null || localSettings === void 0 ? void 0 : localSettings.harvestEmployeeMapping))
            return;
        const newHarvestEmployeeMapping = [...localSettings === null || localSettings === void 0 ? void 0 : localSettings.harvestEmployeeMapping];
        const newValue = { ...newHarvestEmployeeMapping[index] };
        if (field === 'harvestName')
            newValue.harvestName = value !== null && value !== void 0 ? value : '';
        else
            newValue.employeeCode = value !== null && value !== void 0 ? value : '';
        if (index >= newHarvestEmployeeMapping.length) {
            newHarvestEmployeeMapping.push(newValue);
        }
        else {
            newHarvestEmployeeMapping[index] = newValue;
        }
        setLocalSettings({
            ...localSettings,
            harvestEmployeeMapping: newHarvestEmployeeMapping
        });
    };
    // Create array containing empty placeholder at end
    const harvestEmployeeMappingWithPlaceholder = !(localSettings === null || localSettings === void 0 ? void 0 : localSettings.harvestEmployeeMapping)
        ? []
        : [...localSettings.harvestEmployeeMapping, { harvestName: '', employeeCode: '' }];
    return (react_1.default.createElement(PageContent_1.default, { title: "Settings" },
        isInitialLoadError
            ? react_1.default.createElement(office_ui_fabric_react_1.MessageBar, { messageBarType: office_ui_fabric_react_1.MessageBarType.error, isMultiline: false, dismissButtonAriaLabel: "Close" }, "Failed to load settings. Something went wrong.")
            : null,
        react_1.default.createElement(office_ui_fabric_react_1.Text, { variant: "xLarge", styles: styles.sectionHeading }, "Harvest Employee Mapping"),
        react_1.default.createElement("table", { style: styles.table },
            react_1.default.createElement("thead", null,
                react_1.default.createElement("tr", null,
                    react_1.default.createElement("th", null, "Name in Harvest"),
                    react_1.default.createElement("th", null, "Employee Code"))),
            react_1.default.createElement("tbody", null, harvestEmployeeMappingWithPlaceholder.map((employeeInfo, idx) => react_1.default.createElement("tr", { key: idx },
                react_1.default.createElement("td", null,
                    react_1.default.createElement(office_ui_fabric_react_1.TextField, { styles: styles.textField, autoComplete: "no", disabled: isLoading, defaultValue: employeeInfo.harvestName, onChange: updateHarvestMapping(idx, 'harvestName') })),
                react_1.default.createElement("td", null,
                    react_1.default.createElement(office_ui_fabric_react_1.TextField, { styles: styles.textField, autoComplete: "no", disabled: isLoading, defaultValue: employeeInfo.employeeCode, onChange: updateHarvestMapping(idx, 'employeeCode') })))))),
        react_1.default.createElement(office_ui_fabric_react_1.Separator, null),
        react_1.default.createElement(office_ui_fabric_react_1.Stack, null,
            react_1.default.createElement(office_ui_fabric_react_1.PrimaryButton, { iconProps: { iconName: 'Save' }, styles: { root: { maxWidth: '160px' } }, text: "Save Settings", disabled: isLoading || isInitialLoadError, onClick: () => localSettings && persistSettings(localSettings) }),
            isLoading && react_1.default.createElement(office_ui_fabric_react_1.Spinner, { size: office_ui_fabric_react_1.SpinnerSize.large }))));
};
exports.default = SettingsPage;
